import HomeHero from "@components/home-hero";
import * as React from 'react';
export default {
  HomeHero,
  React
};